'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_IO = require("../Relude_IO.bs.js");
var Relude_Int = require("../Relude_Int.bs.js");
var Relude_Float = require("../Relude_Float.bs.js");
var Relude_String = require("../Relude_String.bs.js");
var Option$BsBastet = require("bs-bastet/bastet/src/Option.bs.js");
var Relude_Option_Instances = require("./Relude_Option_Instances.bs.js");

function OptionEqExtensions(E) {
  var eq = function (param, param$1) {
    return Relude_Option_Instances.eqBy(E.eq, param, param$1);
  };
  return {
          eq: eq
        };
}

function OptionOrdExtensions(O) {
  var OptionOrd = Relude_Option_Instances.Ord(O);
  return {
          OptionOrd: OptionOrd,
          compare: OptionOrd.compare
        };
}

function eq(param, param$1) {
  return Relude_Option_Instances.eqBy(Relude_String.Eq.eq, param, param$1);
}

var OptionOrd = Relude_Option_Instances.Ord(Relude_String.Ord);

var String_compare = OptionOrd.compare;

var $$String = {
  eq: eq,
  OptionOrd: OptionOrd,
  compare: String_compare
};

function eq$1(param, param$1) {
  return Relude_Option_Instances.eqBy(Relude_Int.Eq.eq, param, param$1);
}

var OptionOrd$1 = Relude_Option_Instances.Ord(Relude_Int.Ord);

var Int_compare = OptionOrd$1.compare;

var Int = {
  eq: eq$1,
  OptionOrd: OptionOrd$1,
  compare: Int_compare
};

function eq$2(param, param$1) {
  return Relude_Option_Instances.eqBy(Relude_Float.Eq.eq, param, param$1);
}

var OptionOrd$2 = Relude_Option_Instances.Ord(Relude_Float.Ord);

var Float_compare = OptionOrd$2.compare;

var Float = {
  eq: eq$2,
  OptionOrd: OptionOrd$2,
  compare: Float_compare
};

function traverse(f, opt) {
  var IoE = Relude_IO.WithError({});
  var TraverseIO = Option$BsBastet.Traversable(IoE.Applicative);
  return Curry._2(TraverseIO.traverse, f, opt);
}

function sequence(opt) {
  var IoE = Relude_IO.WithError({});
  var TraverseIO = Option$BsBastet.Traversable(IoE.Applicative);
  return Curry._1(TraverseIO.sequence, opt);
}

var IO = {
  traverse: traverse,
  sequence: sequence
};

exports.OptionEqExtensions = OptionEqExtensions;
exports.OptionOrdExtensions = OptionOrdExtensions;
exports.$$String = $$String;
exports.Int = Int;
exports.Float = Float;
exports.IO = IO;
/* OptionOrd Not a pure module */
